import { render, staticRenderFns } from "./sinan-block.vue?vue&type=template&id=59b8702e&scoped=true&lang=pug&"
import script from "./sinan-block.vue?vue&type=script&lang=js&"
export * from "./sinan-block.vue?vue&type=script&lang=js&"
import style0 from "./sinan-block.vue?vue&type=style&index=0&id=59b8702e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b8702e",
  null
  
)

export default component.exports